// Speed reps animation — the signature interactive on
// /pillars/speed/. A dot travels along a 20-second timeline
// through four phases (work → recovery → work → reset) on loop.
// Play toggles play/pause. Reset drops back to start.

const LOOP_MS = 20000;

export default function speedReps() {
    const root = document.querySelector("[data-speed-reps]");
    if (!root) return;

    const dot = root.querySelector("[data-speed-reps-dot]");
    const trail = root.querySelector("[data-speed-reps-trail]");
    const label = root.querySelector("[data-speed-reps-label]");
    const playBtn = root.querySelector("[data-speed-reps-play]");
    const resetBtn = root.querySelector("[data-speed-reps-reset]");
    const playLabel = root.querySelector("[data-speed-reps-play-label]");

    if (!dot || !trail || !label || !playBtn || !resetBtn) return;

    let playing = false;
    let rafId = null;
    let startTs = 0;
    let pausedAt = 0;

    function setDot(pct, state, lbl) {
        dot.style.left = pct + "%";
        trail.style.width = pct + "%";
        label.style.left = pct + "%";
        label.innerHTML = "<b>" + lbl + "</b>";
        dot.classList.toggle("is-resting", state === "rest");
        label.classList.toggle("is-resting", state === "rest");
    }

    function render(ts) {
        const elapsed = (ts - startTs) % LOOP_MS;
        let pct;
        let state;
        let lbl;
        if (elapsed < 6000) {
            pct = (elapsed / 6000) * 50;
            state = "work";
            lbl = "Gear 4 · work";
        } else if (elapsed < 12000) {
            pct = 50 + ((elapsed - 6000) / 6000) * 20;
            state = "rest";
            lbl = "Gear 2 · recovery";
        } else if (elapsed < 16000) {
            pct = 70 + ((elapsed - 12000) / 4000) * 25;
            state = "work";
            lbl = "Gear 4 · work";
        } else {
            pct = 95;
            state = "rest";
            lbl = "Breathe · reset";
        }
        setDot(pct, state, lbl);
        if (playing) rafId = requestAnimationFrame(render);
    }

    function play() {
        if (playing) return;
        playing = true;
        startTs = performance.now() - pausedAt;
        rafId = requestAnimationFrame(render);
        if (playLabel) playLabel.textContent = "Pause";
    }

    function pause() {
        if (!playing) return;
        playing = false;
        pausedAt = performance.now() - startTs;
        if (rafId) cancelAnimationFrame(rafId);
        if (playLabel) playLabel.textContent = "Resume";
    }

    function reset() {
        pause();
        pausedAt = 0;
        setDot(0, "work", "Start · at the line");
        if (playLabel) playLabel.textContent = "Watch one rep";
    }

    playBtn.addEventListener("click", () => {
        if (playing) pause();
        else play();
    });
    resetBtn.addEventListener("click", reset);

    reset();
}
